import clsx from "clsx";
import Carousel, { NextButton, PrevButton, StepRendererProps } from "components/carousel";
import IndicatorDots from "components/carousel/indicator-dots";
import { withCarousel } from "components/carousel/use-carousel";
import React, { ForwardedRef, forwardRef } from "react";

import ItemContent from "./item-content";
import features from "./list";

const StepRenderer = forwardRef<HTMLDivElement, StepRendererProps>(
  ({ step, className }: StepRendererProps, ref: ForwardedRef<HTMLDivElement> | undefined) => (
    <div className={clsx("inline-flex items-center flex-col", className)} ref={ref}>
      <ItemContent {...step} />
    </div>
  )
);
StepRenderer.displayName = "StepRenderer";

const MobileList = () => (
  <div className="lg:hidden">
    <div className="space-y-2">
      <div className="flex justify-center items-center space-x-4">
        <PrevButton className="p-0 text-gray-300 transition-opacity disabled:opacity-30" />
        <IndicatorDots inactiveClassName="bg-gray-300" />
        <NextButton className="p-0 text-gray-300 transition-opacity disabled:opacity-30" />
      </div>
      <Carousel StepRenderer={StepRenderer} />
    </div>
  </div>
);

export default withCarousel(MobileList, { steps: features });
